module.exports = __webpack_public_path__ + "static/assets/ac6d4216d424b165ba317fe4e997d6da.svg";